// extracted by mini-css-extract-plugin
module.exports = {"cells":"NotifyingCompaniesTable_cells__C0kBC"};